<div class="tab-container mat-typography">
  <div class="layout-row align-start">
    <div class="m-b-10">
      <h3>{{ datatableName }}</h3>
    </div>
    <div class="action-button m-b-7 gap-10px">
      <span *LOSxHasPermission="'CREATE_' + datatableName">
        <button mat-raised-button color="primary" (click)="add()">
          <fa-icon icon="plus" class="m-r-10"></fa-icon>{{ 'labels.buttons.Add' | translate }}
        </button>
      </span>
      <ng-container *LOSxHasPermission="'DELETE_' + datatableName">
        @if (isSelected) {
          <span>
            <button class="delete-button" mat-raised-button color="warn" (click)="deleteSelected()">
              <fa-icon icon="trash" class="m-r-10"></fa-icon>
              {{ 'labels.buttons.Delete Selected' | translate }}
            </button>
          </span>
        }
      </ng-container>
      <ng-container *LOSxHasPermission="'DELETE_' + datatableName">
        @if (datatableData.length > 0) {
          <span>
            <button class="delete-button" mat-raised-button color="warn" (click)="delete()">
              <fa-icon icon="trash" class="m-r-10"></fa-icon>
              {{ 'labels.buttons.Delete All' | translate }}
            </button>
          </span>
        }
      </ng-container>
    </div>
  </div>

  <div class="m-t-10">
    <table #dataTable mat-table [dataSource]="datatableData" class="mat-elevation-z1 m-b-25">
      @for (datatableColumn of datatableColumns; track datatableColumn; let i = $index) {
        <ng-container [matColumnDef]="datatableColumn">
          @if (i === 0) {
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let data">
              <mat-checkbox
                class="center"
                (click)="$event.stopPropagation()"
                (change)="$event ? itemToggle(data) : null"
                [checked]="selection.isSelected(data)"
              >
              </mat-checkbox>
            </td>
          }
          @if (i > 0) {
            <th mat-header-cell class="right" *matHeaderCellDef>{{ getInputName(datatableColumn) }}</th>
            <td mat-cell class="right" *matCellDef="let data" [ngClass]="isToDelete(data)">
              {{ formatValue(data, datatableColumn) }}
            </td>
          }
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="datatableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: datatableColumns"></tr>
    </table>
  </div>
</div>
